
import Orleans71 from './Orleans 7 (1).webp'
import Orleans72 from './Orleans 7 (2).webp'
import Orleans73 from './Orleans 7 (3).webp'
import Orleans74 from './Orleans 7 (4).webp'
import Orleans75 from './Orleans 7 (5).webp'
import Orleans76 from './Orleans 7 (6).webp'
import Orleans77 from './Orleans 7 (7).webp'
import Orleans78 from './Orleans 7 (8).webp'
import Orleans79 from './Orleans 7 (9).webp'
import Orleans710 from './Orleans 7 (10).webp'
import Orleans711 from './Orleans 7 (11).webp'

const Orleans7images =[
Orleans71,Orleans72,Orleans73,Orleans74,Orleans75,Orleans76,Orleans77,Orleans78,Orleans79,Orleans710,Orleans711
]

export default Orleans7images;